import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsAdvocatingModel } from './types';
import legalAssociationsAdvocatingItemValidator from './validators/item';

const legalAssociationsAdvocatingValidator: ValidateJSModel<LegalAssociationsAdvocatingModel> = {
  HasAdvocated: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasAdvocated?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsAdvocatingItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsAdvocatingValidator;
